/**
 * Customer types (type and description) as provided by Atul in RI team in Feb 2022.
 * For determining whether only the "individual" or "business" or both buttons will be displayed
 * in the "Your Information" screen based on user's selected DMV service.
 */
export default [
  {
    id: 1,
    type: 'INDIVIDUAL',
    description: 'Allow Individual Customer only from Reservation System'
  },
  {
    id: 2,
    type: 'BUSINESS',
    description: 'Allow Business Customer only from Reservation System'
  },
  {
    id: 3,
    type: 'BOTH',
    description: 'Allow Both Individual and Business Customer from Reservation System'
  },
  {
    id: 4,
    type: 'NONE',
    description: 'No Customer is required for the transaction. ' +
      'This value may not be required from the Reservation system but may be used in the future RIMS transactions'
  }
]